module.exports = __webpack_public_path__ + "img/room20.6233ef97.png";